import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PedidoItemDRPViewComponent } from './pedido-item-drp-view.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PedidoItemDRPViewComponent
    ],
    exports: [
        PedidoItemDRPViewComponent
    ]
})
export class PedidoItemDRPViewModule { }
